import { useCallback, useRef } from "react";
import { ApiService } from "../../../api";
import ProjectTeamService from "../../../api/services/project/project-team-service";

/**
 * Normalizes user search results to a consistent format
 * @param {Object} data - Raw API response data
 * @returns {Array} Normalized user objects
 */
const normalizeSearchResults = (data) => {
	const arr = data?.contents || data?.content || data || [];
	return arr.map((u) => {
		const displayName = u?.displayName || u?.email || [u?.firstName, u?.lastName].filter(Boolean).join(" ");
		return {
			...u,
			id: u.id,
			displayName,
			name: displayName,
		};
	});
};

/**
 * Hook for searching users in project and company
 * @param {string} projectId - Current project ID
 * @returns {Function} Search request function
 */
const useSearchUsers = (projectId) => {
	const cancelTokenSourceRef = useRef(null);

	return useCallback(
		({ search: s }) => {
			if (!cancelTokenSourceRef.current) {
				cancelTokenSourceRef.current = ApiService.getCancelTokenSource();
			}
			if (!projectId) {
				return Promise.resolve([]);
			}

			return ProjectTeamService.searchUsersInProjectAndCompany(
				{ projectId },
				s || "",
				cancelTokenSourceRef.current.token
			).then(normalizeSearchResults);
		},
		[projectId]
	);
};

export default useSearchUsers;
